import {
  ChangeEvent, Dispatch, SetStateAction
} from "react";

import { formatBankAccount, formatBankAgency } from "utils/format";

import { IBankFormData } from "../interfaces";

interface IHandleInputChangeProps {
  event: ChangeEvent<HTMLInputElement>;
  setState: Dispatch<SetStateAction<IBankFormData>>;
}

export const HandleInputChange = ({
  event, setState
}: IHandleInputChangeProps) => {
  const { name, value } = event.target;

  console.log(name)

  switch (name) {
    case "agency": {
      setState(prevState => ({
        ...prevState,
        agency: formatBankAgency(value)
      }))
      break;
    }
    case "account": {
      setState(prevState => ({
        ...prevState,
        account: formatBankAccount(value)
      }))
      break;
    }
    default : {
      setState(prevState => ({
        ...prevState,
        [name]: value
      }))
    }
  }
}
